import React, { useState, useRef } from "react";
import climatologyJSON from "./climatologyJSON.json";
import "./Earth.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowPointer,
  faChevronLeft,
  faImage,
  faTemperature0,
  faTemperature2,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

const host = process.env.REACT_APP_HOST;

const Earth = ({ earthRightValue, toggleEarthSwitcher }) => {
  const [imageURL, setImageURL] = useState("");
  const [showData, setShowData] = useState(false);
  const [pictureAvailable, setPictureAvailable] = useState(false);
  const climateData = useRef();
  const [showPicture, setShowPicture] = useState(false);
  const climatePicture = useRef();

  //---------------------------------------------This is used to determine if we have the picture that corresponds---------------------------------------//
  /**
   * This function modifies the input to correspond to backend formatting
   * @param {*} input
   * @returns
   */
  const extractVariable = (input) => {
    // Remove parentheses and content inside them
    let result = input.replace(/\([^)]*\)/g, "");
    // Convert to lowercase
    result = result.toLowerCase();
    // Remove any leading or trailing whitespace
    result = result.trim();
    return result;
  };
  //-------------------------------------------------------------------------------------------------------------------------------------------------------//'
  /**
   * This function looks for a pisture in the backend with the name of the site and its climatology measurement
   * @param {*} name
   * @param {*} param
   */
  const getPictures = (name, param) => {
    const paramModified = extractVariable(param);
    console.log("kanei axios");
    axios
      .get(`${host}/getClimatologyPictures/${name}/${paramModified}`, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        console.log(response);
        const blob = new Blob([response.data], { type: "image/png" });
        setImageURL(URL.createObjectURL(blob));
        setShowPicture(true);
        setPictureAvailable(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setPictureAvailable(false);
        setShowPicture(true);
      });
  };

  //name here is the object title aka teh sitename
  /**
   * This function uses the site name to show the div and place the correct picture in it
   * @param {*} name
   * @param {*} index
   */
  const handleEarthClick = (name, index) => {
    console.log("area clicked", name);
    climateData.current = showClimaData(name, index);
    setShowData(true);
  };
  /**
   * This function creates the window for the picture to be and depending if it exists or not sends the appropriate response
   * @param {*} name
   * @param {*} index
   * @returns Divs with site picture
   */
  const showClimaData = (name, index) => {
    const locationData = climatologyJSON.climatology[index];

    if (!locationData) {
      // Handle the case where the location data is not found
      return null;
    }

    function transformKey(key) {
      const pattern = /\$\^\{(.*?)\}\$(.*?)/g;
      const replacements = {
        o: "°",
      };
      return key.replace(pattern, (match, unit, measure) => {
        return (
          (replacements[unit] || unit) + (replacements[measure] || measure)
        );
      });
    }

    return (
      <div key={index} className="clima-data">
        <div className="clima-close-button" onClick={() => setShowData(false)}>
          <FontAwesomeIcon icon={faChevronLeft} /> Back
        </div>
        <div className="clima-header">
          <h2>{name}</h2>
        </div>
        <div className="data-text">
          {Object.entries(locationData[name]).map(
            ([param, data], dataIndex) => (
              <div key={dataIndex} className="clima-data-values">
                <div className="picture-icon">
                  <FontAwesomeIcon
                    icon={faImage}
                    onClick={() => getPictures(name, param)}
                  />
                </div>
                <div>{transformKey(param)}:</div>
                <div
                  style={{ fontWeight: data.significant ? "bold" : "normal" }}
                >
                  {data.value}
                </div>
              </div>
            )
          )}
        </div>
      </div>
    );
  };

  //Make all teh buttons
  //   const locationButtons = climatologyJSON.climatology.map((location, index) => (
  //     //surround them in divs so the display flex works
  //     <div className="climatology-button" id="climatology-button">
  //       <div
  //         className={`inside-text`}
  //         onClick={() => handleClimaClick(Object.keys(location)[0], index)}
  //       >
  //         {Object.keys(location)[0]}
  //       </div>
  //     </div>
  //   ));

  return (
    <>
      <div
        className="earth-container"
        id="earth-container"
        style={{
          width: showData ? "400px" : "200px",
          right: `${earthRightValue}`,
        }}
      >
        <div className="earth-nav">
          <div className="feature-info-nav-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
            >
              <path
                fill="#ffffffff"
                d="M7.853.717a1.19 1.19 0 0 0-.65.17L4.53 2.49c-.53.317-.732.984-.467 1.543l.93 1.958a9.217 9.217 0 0 0-1.745 3.076l-2.124.135A1.198 1.198 0 0 0 0 10.399v3.116a1.2 1.2 0 0 0 1.084 1.194l2.171.21a9.207 9.207 0 0 0 1.748 3.066l-.941 1.982a1.198 1.198 0 0 0 .467 1.543l2.673 1.603a1.2 1.2 0 0 0 1.605-.347l1.22-1.771a9.22 9.22 0 0 0 1.971.216c.032 0 .064-.004.096-.004a9.245 9.245 0 0 0 1.876-.212l1.22 1.77a1.2 1.2 0 0 0 1.606.348l2.673-1.603c.53-.317.732-.984.467-1.543l-.941-1.982c.022-.025.048-.049.07-.076c.066-.077.125-.159.188-.238a9.225 9.225 0 0 0 1.484-2.736l2.138-.137A1.198 1.198 0 0 0 24 13.601v-3.116a1.2 1.2 0 0 0-1.084-1.194V9.29l-2.16-.21a9.182 9.182 0 0 0-1.501-2.786c-.063-.08-.124-.16-.19-.238c-.018-.022-.039-.043-.058-.065l.93-1.958a1.198 1.198 0 0 0-.467-1.543L16.797.887a1.2 1.2 0 0 0-1.605.347L13.99 2.976a9.169 9.169 0 0 0-1.896-.219c-.033 0-.064-.004-.096-.004a9.2 9.2 0 0 0-1.992.223L8.808 1.234a1.2 1.2 0 0 0-.955-.517zm4.148 3.882c.574 0 1.13.072 1.668.197a7.41 7.41 0 0 1 5.384 4.993a7.36 7.36 0 0 1 .332 2.193c0 .764-.116 1.5-.332 2.193a7.407 7.407 0 0 1-5.384 4.992a7.393 7.393 0 0 1-1.668.199c-4.071 0-7.384-3.313-7.384-7.384c0-4.07 3.313-7.383 7.384-7.383zM11.907 6C9.558 6 8.429 7.207 8.429 7.207c3.501-1.577 5.23 2.986 6.702 4.386c1.472 1.4 2.887.203 2.887.203c-.012-.787-.252-1.533-.252-1.533c-.968.168-1.398-.494-1.97-1.252C15.224 8.253 13.561 6 11.907 6zm-3.84 3.228c-.705.015-1.3.35-1.653 1c-.868 1.601-.096 3.64-.096 3.64s.3-1.532 1.537-1.309c1.238.224 1.754 1.208 2.504 1.985c.75.776 1.895 2.064 3.978 2.064c2.082 0 3.018-1.516 3.435-2.937v-.002l-.053.04c-1.265.98-3.335.882-4.548-.275c-.89-.846-1.403-1.908-2.135-2.68c-.981-1.038-2.065-1.545-2.97-1.526z"
              />
            </svg>
          </div>
          <div className="feature-info-nav-title">Google Earth Engine</div>
          <button
            className="feature-info-tab-close-btn"
            onClick={() => toggleEarthSwitcher()}
          >
            ×
          </button>
        </div>
        {!showData ? (
          <div className="earth">
            <div className="earth-button" id="earth-button">
              <div
                className="inside-text"
                href="https://ee-danielecerra.projects.earthengine.app/view/sstefanofire28june2022
"
              >
                <a
                  href="https://ee-danielecerra.projects.earthengine.app/view/sstefanofire28june2022"
                  class="fill-div"
                >
                  St Stefano fire (28/06/2022)
                </a>
              </div>
            </div>
            <div className="earth-button" id="earth-button">
              <div className="inside-text">
                <a
                  href="https://ee-danielecerra.projects.earthengine.app/view/mussels-anomaly---neuchatel---concise"
                  class="fill-div"
                >
                  Mussels Anomaly at Neuchâtel.
                </a>
              </div>
            </div>
          </div>
        ) : (
          climateData.current
        )}
      </div>
      {showPicture && (
        // <div className="picture-view-container">
        <div className="clima-picture-container">
          <div
            className="picture-close-button"
            onClick={() => setShowPicture(false)}
          >
            ✖
          </div>
          {pictureAvailable ? (
            <div className="picture">
              <img src={imageURL} alt="picture" className="clima-picture" />
            </div>
          ) : (
            <div className="no-picture-container">
              <div className="clima-no-picture-image-container">
                <img
                  className="clima-no-picture-image"
                  src={require("../loginPictures/Triquetra-logo-300x285.png")}
                  alt="login-logo"
                />
              </div>
              <div className="clima-no-picture">No chart available</div>
            </div>
          )}
        </div>
        // </div>
      )}
    </>
  );
};

export default Earth;
